export class AllRecommendationsInput {
  titleFilter: string
  userId: number
  typeId: number
  loggedInUserId: number;
  showInActive: boolean = false;
}
